import { render, staticRenderFns } from "./Preco.vue?vue&type=template&id=06b4e0cd&"
import script from "./Preco.vue?vue&type=script&lang=js&"
export * from "./Preco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports